import PosthogService from '~/services/posthog/PosthogService';

export interface IReferralLinkedSuccessPayload {
  /** The six-character code as submitted, normalised. */
  referral_code: string;
}

/**
 * Fires when a resolved referral code rode a **completed** sign-up.
 * Event: dental_portal:referrals:linked_success
 *
 * Both halves matter, and the second is why this is not emitted from
 * `gateSignUpOnReferralCode` alongside its sibling. The gate runs before the
 * sign-up call, so firing there counted a code that resolved and then went
 * nowhere — an already-registered email emitted a success for an account that
 * was never created. `SignUpForm` fires it from the mutation's `onSuccess`.
 *
 * `fireReferralLinkedFailed` stays at gate time, because a code that did not
 * resolve did not resolve however the sign-up ends. The two therefore sit at
 * different points in the funnel.
 *
 * The action segment matches mobile's `mobile:referrals:linked_success`
 * deliberately (GOTU-8354): the two differ only in the platform prefix, so web
 * and mobile referral sign-ups union into one funnel. That is also why the area
 * segment is `referrals` rather than `office_signup`, where the rest of the
 * sign-up events sit.
 *
 * No `referrer_id`: the link carries a code, never the referring professional's
 * id (GOTU-6524), and the by-code lookup answers only a masked display name. No
 * account id either — attribution is asynchronous, and the join to a referrer
 * happens server-side off `referredByCode` on the registration event. So this
 * still is not "a referral was created": it says the code resolved and an
 * account now exists for it to attach to.
 */
export function fireReferralLinkedSuccess(payload: IReferralLinkedSuccessPayload): void {
  PosthogService.getInstance().track('dental_portal:referrals:linked_success', {
    referral_code: payload.referral_code,
  });
}
